"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createProductDefaultDataBinding } from "@/libs/commerce/ProductContent";

import { PRODUCT_TEASER_CAROUSEL_INPUTS } from "./ProductTeaserCarousel.inputs";

export const ProductTeaserCarouselComponent: RegisteredComponent = {
  name: "ProductTeaserCarousel",
  friendlyName: "Product Teaser Carousel",
  component: dynamic(async () => (await import("./ProductTeaserCarousel")).ProductTeaserCarousel, { ssr: false }),
  models: [getBuilderModelName("product")],
  inputs: PRODUCT_TEASER_CAROUSEL_INPUTS,
  defaults: {
    bindings: createProductDefaultDataBinding<BindableInputs>({
      items: "teaserProducts",
    }),
  },
};

type BindableInputs = Extract<ArrayElement<typeof PRODUCT_TEASER_CAROUSEL_INPUTS>, { name: "items" }>[];
